/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".img-zoom-container[_ngcontent-%COMP%] {\r\n    position: relative;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n}\r\n\r\n\r\n\r\n.img-zoom-lens[_ngcontent-%COMP%] {\r\n    position: absolute;\r\n    \r\n}\r\n\r\n.clearfix[_ngcontent-%COMP%]:after {\r\n    display: block;\r\n    clear: both;\r\n    content: \"\";\r\n}"];
export { styles as styles };
